<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Ordre" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'hmm'">
					<text-view label="Tekst før pris" v-model="entity.description" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'hmm'">
					<text-view label="Tekst efter pris" v-model="entity.comments" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger (administrationen)" v-model="entity.remarks" :height="250" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<text-view label="Bemærkninger (alle)" v-model="entity.remarks_all" :height="250" :optional="true" />
				</div>
				<div v-show="active == 'customer' && entity._embedded.contact && entity._embedded.contact.details && entity._embedded.contact.details != ''">
					<info-view>{{ entity._embedded.contact ? entity._embedded.contact.details : '' }}</info-view>
				</div>
				<div v-show="active == 'customer'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" @select="selectCustomer" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Telefon" v-model="entity.customer.phone" :optional="true" />
					<string-view label="E-mail" v-model="entity.customer.email" :optional="true" />
				</div>
				<div v-show="active == 'customer'">
					<string-view label="Navn" v-model="entity.customer.name" />
					<string-view label="Att." v-model="entity.customer.att" :optional="true" />
				</div>
				<address-view v-show="active == 'customer'" v-model="entity.customer.address" />
				<div v-show="active == 'customer'">
					<string-view v-for="(number, i) in _numbers" :label="number.label" v-model="entity.customer.numbers[number.name]" :key="i" :optional="true" />
				</div>
				<div v-show="active == 'order'">
					<info-view v-if="_hour_warning">Der er ikke faktureret timer</info-view>
					<order-view v-model="entity.order_lines" :altPrices="prices" />
					<string-view label="Andet faktureret total" v-model="entity.invoiced_total" :optional="true" />
				</div>
				<div v-show="active == 'template'">
					<select-view label="Skabelon" v-model="entity.template_id" :options="templates" optionValueName="id" />
				</div>
				<div v-show="active == 'template'">
					<string-view label="Opbevaring" v-model="entity.template.storage" />
					<div class="side-window__heading">
						Vis med moms
						<switch-view v-model="entity.template.storage_vat" />
					</div>
				</div>
				<div v-show="active == 'template'">
					<div v-for="(line, i) in _lines" :key="i" class="side-window__heading" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 50px;" :title="line">
						{{ line }}
						<switch-view :value="entity.template.incl.includes(line)" @input="inclInput($event, line)" />
					</div>
				</div>
				<div v-show="active == 'template'">
					<text-view label="Evt. andet" v-model="entity.template.extra" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'template' && _template && _template.ps_editable">
					<text-view label="Efterskrift" v-model="entity.template.ps" :height="180" :optional="true" />
				</div>
				<div v-show="active == 'tasks'">
					<task-list-view v-model="entity._embedded.tasks" :template="{
						department_id: entity.department_id,
						contact_id: entity.contact_id,
						employee_id: entity.employee_id,
						name: entity.customer.name,
						email: entity.customer.email,
						phone: entity.customer.phone,
						details: {
							address: entity.customer.address,
							route: [
								{
									address: 	entity.customer.address.address,
									zip: 		entity.customer.address.zip,
									city: 		entity.customer.address.city,
									country: 	entity.customer.address.country
								}
							]
						},
						_embedded: {
							employee: entity._embedded.employee,
							contact: entity._embedded.contact
						}
					}" :mask="['move', 'courier']" />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.files" />
				</div>
				<div v-show="active == 'approvals'">
					<approval-view v-model="entity._embedded.approvals" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Status" @click="onActionButtonClick" />
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import TaskListView from '../views/TaskListView';
	import AddressView from '../views/AddressView';
	import ApprovalView from '../views/ApprovalView';

	import OrderModel from '../model/Order'
	import ContactModel from '../model/Contact'

	import merge from '../functions/merge'

	import ContextPopupView from '../views/ContextPopupView'

	export default {
		data: function () {
			return {
				//packaging: [],
				//ORDER: [],
				prices: [],
				entity: {},
				active: 'details',
				//instructions: [],
				departments: [],
				staticNumbers: [
					{
						name: 'vat',
						label: 'CVR',
						default: ''
					},
					{
						name: 'ean',
						label: 'EAN',
						default: ''
					}
				],
				numbers: [],
				status: [],
				templates: []
				//motivations: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			},
			_template(n) {
				if (this.entity.id) return;
				this.entity.template.extra = n.other;
			},
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView,
			'ApprovalView': ApprovalView
		},
		computed: {
			_hour_warning() {
				// Has hour task
				var hourTask = false;

				for (var i = 0; i < this.entity._embedded.tasks.length; ++i) {
					var t = this.entity._embedded.tasks[i];

					if (t.hour_rate > 0) {
						hourTask = true;
						break;
					}
				}

				// Has hours line
				var hourLine = false;

				for (i = 0; i < this.entity.order_lines.length; ++i) {
					var l = this.entity.order_lines[i];

					if (l.unit == 'timer') {
						hourLine = true;
						break;
					}
				}

				// Return
				return hourTask && !hourLine;
			},
			tabs: function () {
				var r = [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'customer',
						label: 'Kunde'
					},
					{
						name: 'order',
						label: 'Pris'
					},
					{
						name: 'template',
						label: 'Udskrift'
					},
					{
						name: 'tasks',
						label: 'Opgaver'
					},
					{
						name: 'files',
						label: 'Filer'
					}
				];

				if (this.entity.hasOwnProperty('id') && this.entity.id !== null) {
					r.push({
						name: 'approvals',
						label: 'Godkendelser'
					});
				}

				return r;
			},
			_template() {
				var self = this;
				return this.templates.find(function (item) { return item.id == self.entity.template_id; });
			},
			_lines() {
				return this._template ? this._template.incl.split("\n") : [];
			},
			_numbers() {
				var r = [];

				for (var i = 0; i < this.staticNumbers.length; ++i) {
					r.push(this.staticNumbers[i]);
				}

				for (i = 0; i < this.numbers.length; ++i) {
					r.push(this.numbers[i]);
				}

				// Add to entity
				var ent = this.entity;
				
				for (i = 0; i < r.length; ++i) {
					if (!ent.customer.numbers.hasOwnProperty(r[i].name)) {
						ent.customer.numbers[r[i].label] = r[i].default;
					}
				}

				

				return r;
			},
			_actions() {
				const self = this;

				return [
					{
						label: 'Åben',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'open'); 
						}
					},
					{
						label: 'Send til e-conomic (faktureret)',
						action() {
							//alert('Varenumre mangler at blive opdateret');

							console.log(self.entity);							

							self.submit(merge({}, self.entity), true);
						}
					},
					{
						label: 'Faktureret',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'invoiced'); 
						}
					},
					{
						label: 'Bogført',
						action() {
							

							// Set invoice date
							//this.invoiced = 'true';

							self.submit(merge({}, self.entity), false, 'closed'); 
						}
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			value: {
				type: Object,
				default() {
					return merge({}, OrderModel.entity());
				}
			},
			lookup: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			onActionButtonClick(event) {
				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: this._actions
				});
			},
			inclInput(val, line) {
				if (val) {
					this.entity.template.incl.push(line);
				} else {
					this.entity.template.incl.splice(this.entity.template.incl.indexOf(line), 1);
				}
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(merge({}, this.entity));
			},
			onSaveAndSetStatus() {
				

				// Set invoice date
				//this.invoiced = 'true';

				this.submit(merge({}, this.entity), false, true); 
			},
			getInvoiceObj(obj) {
				if (obj._embedded.invoice_contact) {
					return this.getInvoiceObj(obj._embedded.invoice_contact);
				} else {
					return obj;
				}
			},
			setNumbers(obj) {
				

				// Use invoice concact numbers
				const inv = this.getInvoiceObj(obj);

				

				for (var i = 0; i < this.numbers.length; ++i) {
					var num = this.numbers[i];
					num.default = num.static ? num.value : '';
					num.name 	= num.label;
				}

				for (i = 0; i < inv.numbers.length; ++i) {
					if (this.numbers.filter((item) => {
						return item.name == inv.numbers[i].label;
					}).length == 0) {
						this.numbers.push({
							name: 		inv.numbers[i].label,
							label: 		inv.numbers[i].label,
							default: 	inv.numbers[i].static ? inv.numbers[i].value : ''
						});
					}
				}

				
			},
			selectCustomer(obj) {
				
				this.numbers = obj.numbers; // Union

				this.setNumbers(obj);

				this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.business ? obj.roles.business.vat : '',
							ean:		obj.roles.business ? obj.roles.business.ean : ''
						}
					}
				});

				this.prices = obj._embedded.prices;
			},
			onSaveAndInvoiceButtonClick() {
				

				this.submit(merge({}, this.entity), true);
			}
		},
		mounted: async function() {
			
			

			var self = this;

			this.entity = merge(OrderModel.entity(), this.value);

			// Remove approvals from no-id
			if (!this.entity.hasOwnProperty('id') || this.entity.id === null) {
				
				this.entity._embedded.approvals = [];
			} else {
				
			}

			

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/orders/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/templates/orders/')
				.then(function (r) {
					self.templates = r.data._items;
				});

			

			if (this.entity.contact_id !== null) {
				

				var obj = await ContactModel.read(this.axios, this.entity.contact_id);

				this.selectCustomer(obj);

				/*this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.hasOwnProperty('business') ? obj.roles.business.vat : '',
							ean:		obj.roles.hasOwnProperty('business') ? obj.roles.business.ean : '',
						}
					}
				});*/
			}
	


			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
